import React from 'react';
import { CheckCircle, PaperPlaneTilt, XCircle, Clock, Flask } from '@phosphor-icons/react';

const STATES = {
  sending: { label: 'Envoi en cours', Icon: Clock, color: 'bg-gray-100 text-gray-700 border-gray-300', hint: 'Envoi en cours ; aucune acceptation confirmée.' },
  accepted: { label: 'Accepté', Icon: PaperPlaneTilt, color: 'bg-sky-50 text-sky-800 border-sky-200', hint: 'Pris en charge par le service email ; livraison non confirmée.' },
  delivered: { label: 'Livré', Icon: CheckCircle, color: 'bg-emerald-50 text-emerald-800 border-emerald-200', hint: 'Livraison confirmée par le serveur destinataire ; lecture non attestée.' },
  rejected: { label: 'Rejeté', Icon: XCircle, color: 'bg-red-50 text-red-800 border-red-200', hint: 'Rejet signalé par le fournisseur email.' },
  failed: { label: 'Échec d’envoi', Icon: XCircle, color: 'bg-red-50 text-red-800 border-red-200', hint: 'Le fournisseur n’a pas accepté cet envoi.' },
  simulated: { label: 'SIMULÉ — non envoyé', Icon: Flask, color: 'bg-gray-100 text-gray-700 border-gray-300', hint: 'Aucun envoi réel au destinataire.' },
  unknown: { label: 'Suivi indisponible', Icon: Clock, color: 'bg-gray-100 text-gray-700 border-gray-300', hint: 'Aucune preuve de livraison disponible.' },
};

export const normalizeEmailStatus = (status, event) => {
  if (['blocked', 'invalid', 'error', 'bounces', 'hardBounces', 'softBounces', 'hardBounce', 'softBounce'].includes(event)) return 'rejected';
  return ({ sent: 'accepted', deferred: 'accepted', bounced: 'rejected', error: 'failed', sent_mock: 'simulated' })[status] || status;
};

export const EmailDeliveryStatus = ({ status, event, testId }) => {
  const state = STATES[normalizeEmailStatus(status, event)] || STATES.unknown;
  const Icon = state.Icon;
  return <span data-testid={testId} title={state.hint} className={`inline-flex max-w-full items-center gap-1.5 rounded-md border px-2 py-1 text-xs font-semibold ${state.color}`}>
    <Icon size={15} className="shrink-0" aria-hidden="true" /><span>{state.label}</span>
  </span>;
};

export const emailDate = (value) => value && !Number.isNaN(Date.parse(value))
  ? new Intl.DateTimeFormat('fr-FR', { dateStyle: 'short', timeStyle: 'medium' }).format(new Date(value)) : '—';